import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'firebird-web-checkbox',
  templateUrl: './checkbox.component.html',
  standalone: false,
})
export class CheckboxComponent {
  @Input()
  checked!: boolean;

  @Input()
  disabled!: boolean;

  @HostBinding('attr.disabled')
  public get hostDisabledAttr(): '' | null {
    return this.disabled ? '' : null;
  }

  @HostBinding('attr.aria-disabled')
  public get hostAriaDisabledAttr(): 'true' | null {
    return this.disabled ? 'true' : null;
  }

  @HostBinding('class.is-disabled')
  public get isDisabledClass(): boolean {
    return !!this.disabled;
  }

  @Input()
  id!: string;

  @Input()
  labelPosition: 'before' | 'after' = 'after';

  @Input()
  name!: string;

  @Input()
  labelKey!: string;

  @Input()
  translateParams = {};

  @Input()
  inputClass!: string;

  @Input()
  isDynamicLabel = false;

  @Output()
  public changeEvent: EventEmitter<Event> = new EventEmitter<Event>();

  public click($event: Event): void {
    if (!this.disabled) {
      this.changeEvent.emit($event);
    }
  }
}
